export default __webpack_public_path__ + "static/media/Neo.b087a8cd.jpg";